import webBiLogger from '@wix/web-bi-logger';
import { hasWixClientId, setWixClientId } from '../utils/login';

interface LogObject {
  evid: number;
  endpoint: string;
  src: number;
  params: { [key: string]: any };
}

export const useBI = () => {
  const biLogger = webBiLogger.factory().logger();

  const sendBIEvent = async (event: LogObject): Promise<void> => {
    if (!hasWixClientId()) {
      setWixClientId();
    }
    await biLogger.report(event);
  };

  return { sendBIEvent };
};
